import { validatenull } from '@/utils/validate'
/**
 * 存储sessionStorage
 */
export const setStore = (params) => {
  const {
    name,
    content,
    type
  } = params
  const obj = {
    dataType: typeof (content),
    content: content,
    type: type,
    datetime: new Date().getTime()
  }
  // 直接放到sessionStorage
  window.sessionStorage.setItem(name, JSON.stringify(obj))
}
/**
 * 获取sessionStorage
 */
export const getStore = (params) => {
  const {
    name
  } = params
  let obj = {}
  let content
  obj = window.sessionStorage.getItem(name)
  if (validatenull(obj)) return
  obj = JSON.parse(obj)
  if (obj.dataType === 'string') {
    content = obj.content
  } else if (obj.dataType === 'number') {
    content = Number(obj.content)
  } else if (obj.dataType === 'object') {
    content = obj.content
  }
  return content
}
/**
 * 删除sessionStorage
 */
export const removeStore = params => {
  const {
    name
  } = params
  window.sessionStorage.removeItem(name)
}


export const localstore = {
  get(key, hour) {
      if (localStorage.getItem(key)) {
          var data = JSON.parse(localStorage.getItem(key)),
              time = data.time,
              value = data.value;
          if (hour && +new Date() - time >= hour * 60 * 60 * 1000) {
              localStorage.removeItem(key);
          } else {
              return value;
          }
      }
  },
  set(key, value) {
      try {
          localStorage.setItem(
              key,
              JSON.stringify({
                  time: +new Date(),
                  value
              })
          );
      } catch (err) {
          localStorage.clear();
      }
  },
  remove(key) {
      localStorage.removeItem(key);
  },
  clearAll() {
      localStorage.clear();
  }
};



// WEBPACK FOOTER //
// ./src/utils/store.js